import SortOrder from '@/constants/SortOrder';

const OpportunitiesSortableFields = {
  askAmount: {
    defaultValue: SortOrder.ASC,
  },
  opportunityStageOrder: {
    defaultValue: SortOrder.ASC,
  },
  constituentName: {
    defaultValue: SortOrder.ASC,
  },
  createdAt: {
    defaultValue: SortOrder.DESC,
    isDefault: true,
  },
};

export default OpportunitiesSortableFields;
